import type { TFunction } from "i18next";
import * as yup from "yup";

export const getRequiredCheckboxSchema = (t: TFunction) =>
  yup.boolean().oneOf([true], t("COMMONS.ERRORS.REQUIRED")).required(t("COMMONS.ERRORS.REQUIRED"));
